/* file description */

import { Button } from 'antd';
import React from 'react';

import { PlusOutlined } from '@ant-design/icons';

import { ERROR_MSG_MAP } from './console_msg/errorMsgs';
import type { UseToolBarRenderProp } from './type';
import { SPTableBaseMode } from './consts';

export const useToolBarRender: UseToolBarRenderProp = ({
  toolBarRender,
  autoAddRecordConfig,
  setAddRecordWrap,
  addRecordWrapVisible,
  tableBaseMode,
  autoPopUp,
}) => {
  if (toolBarRender) {
    return toolBarRender;
  }
  if (!autoAddRecordConfig) {
    return () => [];
  }
  // 只读模式
  if (tableBaseMode === SPTableBaseMode.VIEW) {
    return () => [];
  }

  if (autoPopUp) {
    const { onAddBtnClick, onSave } = autoAddRecordConfig;
    const handleClick = () => {
      if (onAddBtnClick) {
        onAddBtnClick();
        return;
      }
      if (!onSave) {
        console.error(ERROR_MSG_MAP.autoAddRecordConfigWithOutOnSave);
        return;
      }
      setAddRecordWrap(true);
    };
    const result = [
      <Button key="button" onClick={handleClick} icon={<PlusOutlined />} type="primary">
        新建
      </Button>,
    ];
    return () => {
      return result;
    };
  }
  return () => {
    return [];
  };
};
